var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28795 17.128C13.8335 17.128 17.9647 10.8752 17.9647 5.45121C17.9647 5.27521 17.9647 5.09601 17.9519 4.92001C18.7551 4.33761 19.4495 3.62081 19.9999 2.79521C19.2511 3.12801 18.4575 3.34561 17.6447 3.44161C18.5023 2.92961 19.1423 2.12321 19.4495 1.17281C18.6431 1.64961 17.7631 1.98881 16.8447 2.16801C15.2895 0.51681 12.6911 0.43681 11.0399 1.98881C9.97435 2.99041 9.52315 4.48481 9.85275 5.90881C6.55355 5.74241 3.47835 4.18401 1.39515 1.62081C0.307148 3.49601 0.860747 5.89281 2.66555 7.09921C2.01275 7.08001 1.37275 6.90401 0.803148 6.58721C0.803148 6.60321 0.803148 6.62241 0.803148 6.63841C0.803148 8.59041 2.17915 10.2736 4.09595 10.6608C3.49115 10.824 2.85755 10.8496 2.24315 10.7312C2.78075 12.4016 4.31995 13.5472 6.07675 13.5824C4.62395 14.7248 2.82875 15.3456 0.982348 15.3424C0.655948 15.3424 0.329548 15.3232 0.00634766 15.2816C1.87515 16.488 4.06075 17.128 6.28795 17.1248",
    fill: "#181B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d3b8788357a1aca9a67a7b0909601617.svg";
export { ForwardRef as ReactComponent };